module.exports = __webpack_public_path__ + "static/media/snakke_lågt.93b1e173.m4a";